module.exports = __webpack_public_path__ + "static/why-planet.35e41f9b.jpg";